import React from 'react'
import { Box } from '@mui/material'


export default function staticColumn(name, label, filterType, displayFilters, display) {
	return {
		name,
		label,
		options: {
			filter: displayFilters,
			display: display,
			headAlign: 'center',
			filterType,
			customBodyRowRenderLite: value => <Box sx={{ textAlign: 'center' }}>
				{value || '-'}
			</Box>
		}
	}
}